import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { scenarios } from '@/mocks/smart-restaurant';

export default function Scenarios() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <SectionHeading
          eyebrow="场景化方案"
          title="适配不同餐饮经营形态"
          subtitle="无论是连锁扩张、供应链管理、聚餐团购还是食材采购，味聚都能按业务链路给出适配的数字化能力。"
        />

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-6">
          {scenarios.map((scenario, idx) => (
            <Reveal key={scenario.id} delay={idx * 60}>
              <div className="group relative overflow-hidden rounded-lg border border-background-200 hover:border-accent-300 transition-colors duration-300">
                <div className="relative h-48 md:h-56 overflow-hidden">
                  <img
                    src={scenario.image}
                    alt={scenario.title}
                    title={`${scenario.title}场景`}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/20 to-transparent"></div>
                  <div className="absolute bottom-4 left-5 flex items-center gap-2.5">
                    <div className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-500 text-foreground-950">
                      <i className={`${scenario.icon} text-base`}></i>
                    </div>
                    <h3 className="font-heading font-bold text-background-50 text-lg md:text-xl">
                      {scenario.title}
                    </h3>
                  </div>
                </div>
                <div className="p-5 bg-background-50">
                  <p className="text-sm text-foreground-600 leading-relaxed">{scenario.desc}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}